export default __webpack_public_path__ + "static/media/EmptyState.8700caf4.svg";